import {getApiList} from "@/api/backend";
import {factoryMutations, factoryState} from "@/store/Modules/_factoryList";
import moment from "moment";

const state = {
  ...factoryState,
};

const mutations = {
  ...factoryMutations,
};

const actions = {
  async fetchList(context, {token, page}) {
    try {
      const list = (await getApiList('/product-time-discounts', token, {page}));
      const result = list.items.map(
        ({id, name, active, discount, dateFrom, dateTo}) => ({
          id,
          name: name ?? '',
          active: active ? 'TAK' : 'NIE',
          discount: (discount * 0.01).toFixed(2),
          dateFrom: moment(String(dateFrom)).format('YYYY-MM-DD HH:mm'),
          dateTo: moment(String(dateTo)).format('YYYY-MM-DD HH:mm'),
        })
      );

      return context.commit('setItems', {items: result, totalItems: list.totalItems});
    } catch ({response}) {
      return context.commit('setApiError', {isError: true, status: response?.status});
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
